import React from 'react';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Loading from '../../components/Common/Loading';
import SignUpBusinessForm from '../../forms/SignUpBusinessForm';
import { submissionError } from '../../actions/formActions';
import { signUpBusiness, setSignUpStep } from '../../actions/signupActions';
import { makeSimpleValue } from '../../utils/formUtils';
import browserHistory from '../../history';

class SignUpBusiness extends React.Component {
  componentDidMount() {
    const { signup, doSetSignupStep } = this.props;
    if (!signup || !signup.first_name) {
      browserHistory.push('/signup');
    } else {
      doSetSignupStep(2);
    }
  }

  render() {
    const { showSubmissionError, doSignUpBusiness, signup } = this.props;
    let businessTypes;
    if (signup) {
      ({ businessTypes } = signup);
    }
    const steps = [
      { number: 1, label: 'Increase revenue' },
      { number: 2, label: 'Grow membership' },
      { number: 3, label: 'Save time' },
    ];
    return (
      <ContentWrapper>
        <Row className="margin-top-80">
          <Col md={6} className="d-flex flex-column align-items-center margin-bottom-80">
            <div className="signup-form-wrapper">
              {signup && businessTypes ? (
                <SignUpBusinessForm
                  showSubmissionError={showSubmissionError}
                  onSubmit={(values) => doSignUpBusiness(values)}
                  businessTypes={businessTypes}
                  initialValues={{
                    phone: signup.phone,
                    name: signup.name,
                    business_type: signup.business_type,
                    former_customer: signup.former_customer,
                    client_count: signup.client_count,
                    other: signup.other,
                    preferred_contact_method: signup.preferred_contact_method,
                    opt_in: signup.opt_in !== undefined ? signup.opt_in : true,
                  }}
                />
              ) : (
                <Loading />
              )}
            </div>
          </Col>
          <Col className="d-flex flex-column align-items-center">
            <div className="signup-form-wrapper">
              <div className="icon-headline-container d-flex align-items-center border-bottom pb-4">
                <img src="/img/signup/icon-step-2.svg" className="mr-4" />
                <h2>Macrostax helps scale your fitness business.</h2>
              </div>

              <div className="signup-steps benefits mt-4 pl-3">
                {steps.map((s) => (
                  <div className="signup-step benefit d-flex" key={s.number}>
                    <div className="signup-step-check mr-3">
                      <em className="fas fa-check" />
                    </div>
                    <div className="signup-step-label">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </ContentWrapper>
    );
  }
}

SignUpBusiness.propTypes = {
  showSubmissionError: PropTypes.func,
  doSignUpBusiness: PropTypes.func,
  signup: PropTypes.instanceOf(Object),
  doSetSignupStep: PropTypes.func,
};
const mapStateToProps = (state) => ({
  signup: state.signup,
});
const mapDispatchToProps = (dispatch) => ({
  showSubmissionError: (errors) => dispatch(submissionError(errors)),
  doSignUpBusiness: (values) => {
    values.businessType = makeSimpleValue(values.businessType);
    values.memberCount = makeSimpleValue(values.memberCount);
    values.usedMacrostax = makeSimpleValue(values.usedMacrostax);
    dispatch(signUpBusiness(values));
  },
  doSetSignupStep: (step) => dispatch(setSignUpStep(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpBusiness);
